type WikiLabelEntry = Readonly<{
  id: string;
  slug: string;
  title: string;
}>;

function titleFromSlug(slug: string): string {
  const last = slug.split("/").at(-1) ?? slug;
  const spaced = last.replace(/-/g, " ");
  return spaced.length
    ? spaced.charAt(0).toUpperCase() + spaced.slice(1)
    : spaced;
}

function countOccurrences(values: readonly string[]): Map<string, number> {
  const counts = new Map<string, number>();

  for (const value of values) counts.set(value, (counts.get(value) ?? 0) + 1);

  return counts;
}

export function distinguishEntryLabels(
  entries: readonly WikiLabelEntry[],
): Map<string, string> {
  let labeledEntries = entries.map((entry) => ({
    entry,
    label: entry.title.trim() || titleFromSlug(entry.slug),
  }));

  for (const fallback of [
    (entry: WikiLabelEntry) => titleFromSlug(entry.slug),
    (entry: WikiLabelEntry) => entry.slug,
  ]) {
    const counts = countOccurrences(labeledEntries.map(({ label }) => label));
    labeledEntries = labeledEntries.map(({ entry, label }) => ({
      entry,
      label: counts.get(label) === 1 ? label : fallback(entry),
    }));
  }

  const labels = labeledEntries.map(({ label }) => label);
  const counts = countOccurrences(labels);
  const used = new Set(labels.filter((label) => counts.get(label) === 1));
  return new Map(
    labeledEntries.map(({ entry, label }) => {
      if (counts.get(label) !== 1) {
        label = entry.slug;
        let suffix = 2;

        while (used.has(label)) {
          label = `${entry.slug} (${suffix})`;
          suffix++;
        }

        used.add(label);
      }

      return [entry.id, label];
    }),
  );
}
